module.exports = __webpack_public_path__ + "img/item-0.a09ce52.png";